import React, { useState } from 'react';

function Accessibility() {
  const [highContrastMode, setHighContrastMode] = useState(false);
  const [fontSize, setFontSize] = useState('medium');
  
  const toggleHighContrast = () => {
    setHighContrastMode(!highContrastMode);
    // Apply high contrast mode to body
    if (!highContrastMode) {
      document.body.classList.add('high-contrast');
    } else {
      document.body.classList.remove('high-contrast');
    }
  };
  
  const changeFontSize = (size) => {
    setFontSize(size);
    document.body.className = document.body.className.replace(/font-size-\w+/g, '');
    document.body.classList.add(`font-size-${size}`);
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '600px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '2rem', color: '#3d4954' }}>
        Accessibility Settings
      </h1>
      
      <div style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#3d4954' }}>
          Visual Settings
        </h2>
        
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '1rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={highContrastMode}
              onChange={toggleHighContrast}
              style={{ width: '20px', height: '20px' }}
            />
            <span style={{ fontSize: '1.1rem' }}>High Contrast Mode</span>
          </label>
          <p style={{ marginTop: '0.5rem', color: '#666', fontSize: '0.9rem' }}>
            Increases contrast for better visibility
          </p>
        </div>
        
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '1.1rem' }}>
            Font Size:
          </label>
          <div style={{ display: 'flex', gap: '1rem' }}>
            {['small', 'medium', 'large', 'extra-large'].map(size => (
              <button
                key={size}
                onClick={() => changeFontSize(size)}
                style={{
                  padding: '0.5rem 1rem',
                  border: fontSize === size ? '2px solid #3b82b8' : '1px solid #ccc',
                  borderRadius: '0.5rem',
                  background: fontSize === size ? '#f0f8ff' : 'white',
                  cursor: 'pointer',
                  textTransform: 'capitalize'
                }}
              >
                {size.replace('-', ' ')}
              </button>
            ))}
          </div>
        </div>
      </div>
      
      <div style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#3d4954' }}>
          Audio Settings
        </h2>
        <p style={{ color: '#666' }}>
          Audio accessibility settings are available during voice sessions with Mira.
        </p>
      </div>
      
      <div style={{ marginTop: '3rem', padding: '1rem', background: '#f5f9fa', borderRadius: '0.5rem' }}>
        <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>
          For additional accessibility support, please contact our support team.
        </p>
      </div>
    </div>
  );
}

export default Accessibility;